import React, { useState, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import MakeLoanDialogue from "./make-loan-dialogue";
import { LoansContext } from "../../contexts/loans-context";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";

export const MakeLoan = (props) => {
  const [isMakeLoanDialogueOpen, setMakeLoanDialogueIsOpen] = useState(false);
  const [selectedPlayerData, setSelectedPlayerData] = useState({});
  const {loansData} = useContext(LoansContext);
  const { getTeamById, getPlayerPositionById, getCurrentWindow } = useSiteVarsFunctions();

  return (
      <TableContainer component={Paper} sx={{paddingBottom: "55px"}}>
      {isMakeLoanDialogueOpen && (
        <MakeLoanDialogue open={isMakeLoanDialogueOpen} playerData={selectedPlayerData} auctionListData={props.auctionListData} key={selectedPlayerData.prem_team_id} handleCloseMakeLoanDialogue={setMakeLoanDialogueIsOpen}/>
      )}
      {props.leaderboardData.length === 0 && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={30} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {(props.clubPlayersArr.length > 0) && (
      <Table sx={{ minWidth: 350 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}></TableCell>
            <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>Player</TableCell>
            <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>Cost</TableCell>
            <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>Points</TableCell>
            <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.clubPlayersArr.map((row) => (
            row.transfer != "in" && (
              <TableRow key={row.last_name}>
              <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}><img src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${row.photo.substr(0, row.photo.indexOf('.'))}.png`} style={{ width: '40px', height: '51px' }} /></TableCell>
              <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}><span>{row.lastName}</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(row.positionId).name_short}</span> {getTeamById(row.teamId).name_short}</TableCell>
              <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>{row.originalCost}</TableCell>
              <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}>{row.totalPoints}</TableCell>
              <TableCell sx={{ paddingLeft: '6px', paddingRight: '6px' }}><Button variant="outlined" size="small" disabled={row.transfer == "out" || 
              loansData.clubCount > 5 || 
              loansData.allLoans?.filter((loan) => loan.playerout === row.playerId && loan.windowid == getCurrentWindow()).length > 0
              }onClick={() => {setSelectedPlayerData(row); setMakeLoanDialogueIsOpen(true)}}>Bench</Button></TableCell>
            </TableRow>
            )
          ))}
        </TableBody>
      </Table>
      )}
      
    </TableContainer>
  );
};
